import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Briefcase, FileText, MessageSquare, Upload, Mail, LogOut, Key, Users } from 'lucide-react';
import { toast } from 'sonner';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    toast.success('Logged out successfully');
    navigate('/admin/login');
  };

  const menuItems = [
    { to: '/admin/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { to: '/admin/jobs', icon: <Briefcase size={20} />, label: 'Jobs' },
    { to: '/admin/blogs', icon: <FileText size={20} />, label: 'Blogs' },
    { to: '/admin/testimonials', icon: <MessageSquare size={20} />, label: 'Testimonials' },
    { to: '/admin/resumes', icon: <Upload size={20} />, label: 'Resumes' },
    { to: '/admin/contacts', icon: <Mail size={20} />, label: 'Contacts' },
    { to: '/admin/subscribers', icon: <Users size={20} />, label: 'Subscribers' },
    { to: '/admin/change-password', icon: <Key size={20} />, label: 'Change Password' },
  ];

  return (
    <div className="flex min-h-screen bg-muted" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar w-64 flex-shrink-0" data-testid="admin-sidebar">
        <div className="p-6">
          <h2 className="text-xl font-bold gold-text mb-2">Vocavi Admin</h2>
          <p className="text-sm text-slate-400">
            {localStorage.getItem('adminUsername')}
          </p>
        </div>

        <nav className="px-3">
          {menuItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`admin-nav-${item.label.toLowerCase()}`}
              className={`flex items-center gap-3 px-4 py-3 mb-1 transition-colors ${
                location.pathname === item.to
                  ? 'bg-secondary/20 text-secondary'
                  : 'text-slate-300 hover:bg-slate-800 hover:text-white'
              }`}
            >
              {item.icon}
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 w-64 p-3">
          <button
            onClick={handleLogout}
            data-testid="admin-logout-button"
            className="flex items-center gap-3 px-4 py-3 w-full text-slate-300 hover:bg-red-600 hover:text-white transition-colors"
          >
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto" data-testid="admin-content">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;